import { paymentService } from "../../services/payment.service";
import { paymentInstrumentService } from "../../services/paymentInstrument.service";
import paymentType from "./paymentInstrumentTypes";
import errorHandler from "../../handlers/errorHandler";

/**
 * Get payment providers
 **/

export const getAllPaymentProviders = (page) => async (dispatch) => {
  try {
    dispatch({ type: paymentType["LOADING_PAYMENT"], payLoad: true });
    const response = await paymentService.getAllPaymentProviders(page);
    dispatch({ type: paymentType["LOADING_PAYMENT"], payLoad: false });
    dispatch({ type: paymentType["ALL_PAYMENT_PROVIDERS"], payLoad: response });
  } catch (error) {
    dispatch({ type: paymentType["LOADING_PAYMENT"], payLoad: false });
  }
};

/**
 * Get my payments
 **/

export const getMyPaymentInstruments = () => async (dispatch) => {
  try {
    dispatch({ type: paymentType["LOADING_PAYMENT"], payLoad: true });
    const response = await paymentInstrumentService.getMyPaymentInstruments();
    dispatch({ type: paymentType["LOADING_PAYMENT"], payLoad: false });
    dispatch({ type: paymentType["MY_PAYMENT_INSTRUMENT"], payLoad: response });
    return response;
  } catch (error) {
    dispatch({ type: paymentType["LOADING_PAYMENT"], payLoad: false });
  }
};

/**
 * Get my payment instruments
 **/

export const storePaymentInstrument = (payload) => async (dispatch) => {
  try {
    dispatch({ type: paymentType["CREATING"], payLoad: true });
    const response = await paymentInstrumentService.storePaymentInstrument(payload);
    dispatch({ type: paymentType["CREATING"], payLoad: false });
    // dispatch({ type: paymentType["MY_PAYMENT_INSTRUMENT"], payLoad: response });
    return response;
  } catch (error) {
    dispatch({ type: paymentType["CREATING"], payLoad: false });
  }
};


/**
 * Delete a payment instrument
 **/

export const deletePaymentInstrument = (payload) => async (dispatch) => {
  try {
    dispatch({ type: paymentType["DELETING"], payLoad: true });
    const response = await paymentInstrumentService.deletePaymentInstrument(payload);
    dispatch({ type: paymentType["DELETING"], payLoad: false });
    // dispatch({ type: paymentType["MY_PAYMENT_INSTRUMENT"], payLoad: response });
    return response;
  } catch (error) {
    dispatch({ type: paymentType["DELETING"], payLoad: false });
  }
};


/**
 * Show a payment
 **/

export const showAPayment = (id) => async (dispatch) => {
  try {
    dispatch({ type: paymentType["LOADING_PAYMENT"], payLoad: true });
    const response = await paymentService.showAPayment(id);
    dispatch({ type: paymentType["LOADING_PAYMENT"], payLoad: false });
    dispatch({ type: paymentType["SINGLE_PAYMENT"], payLoad: response });
    return response;
  } catch (error) {
    dispatch({ type: paymentType["LOADING_PAYMENT"], payLoad: false });
  }
};


/**
 * Filter a payment
 **/

export const filterPayment = (payLoad, pagex) => async (dispatch) => {
  try {
    dispatch({ type: paymentType["FILTERING_PAYMENT"], payLoad: true });
    const response = await paymentService.filterPayment(payLoad, pagex);
    dispatch({ type: paymentType["FILTERING_PAYMENT"], payLoad: false });
    dispatch({ type: paymentType["FILTER_PAYMENT"], payLoad: response });
    return response;
  } catch (error) {
    dispatch({ type: paymentType["FILTERING_PAYMENT"], payLoad: false });
  }
};

/**
 * Get all restaurants
 **/

export const getAllPaymentsNoPagination = (payload) => async (dispatch) => {
  try {
    dispatch({ type: paymentType["DOWNLOADING"], payLoad: true });
    const response = await paymentService.getAllPaymentsNoPagination(payload);
    dispatch({ type: paymentType["DOWNLOADING"], payLoad: false });
    dispatch({
      type: paymentType["ALL_PAYMENT_NO_PAGINATION"],
      payLoad: response,
    });
    return response;
  } catch (error) {
    dispatch({ type: paymentType["DOWNLOADING"], payLoad: false });
    errorHandler(error, true);
  }
};

/**
 * Search payments
 **/

export const searchPayments = (params) => async (dispatch) => {
  try {
    dispatch({ type: paymentType["LOADING_SEARCH"], payLoad: true });
    const response = await paymentService.searchPayments(params);
    dispatch({ type: paymentType["LOADING_SEARCH"], payLoad: false });
    dispatch({ type: paymentType["SEARCH_PAYMENT"], payLoad: response });
    return response;
  } catch (error) {
    dispatch({ type: paymentType["LOADING_SEARCH"], payLoad: false });
    errorHandler(error, true);
  }
};
